<template>
    <div>
        <b-button v-b-modal.modal-1 variant='primary'>
            <font-awesome-icon icon='pen' />
            Compose
        </b-button>

        <b-modal id='modal-1' hide-header hide-footer>
            <font-awesome-icon
                icon='times'
                class='icon-close fa-close-btn fa-fw'
                @click='$bvModal.hide(`modal-1`)'
            />

            <!-- Accounts selector -->
            <b-input-group id='input-group'>
                <vue-tags-input
                    v-model='account'
                    placeholder='Select social media profiles'
                    :tags='accounts'
                    :autocomplete-items='filteredItems'
                    :add-only-from-autocomplete='true'
                    :autocomplete-min-length='0'
                    @tags-changed='newTags => (accounts = newTags)'
                >
                    <div
                        slot='autocomplete-item'
                        slot-scope='props'
                        @click='props.performAdd(props.item)'
                    >
                        <b-img
                            :src='props.item.avatar'
                            width='20%'
                            rounded='circle'
                            fluid
                        ></b-img>
                        &nbsp;
                        <font-awesome-icon
                            :icon='[props.item.fa, props.item.network]'
                        />
                        &nbsp;{{ props.item.text.split(/ (.+)/)[1] }}
                    </div>
                    <div slot='tag-left' slot-scope='props'>
                        <b-img
                            :src='props.tag.avatar'
                            width='20%'
                            rounded='circle'
                            fluid
                        ></b-img>
                        &nbsp;
                        <font-awesome-icon
                            :icon='[props.tag.fa, props.tag.network]'
                        />
                        &nbsp;
                    </div>
                    <div slot='tag-center' slot-scope='props'>
                        {{ props.tag.text.split(/ (.+)/)[1] }}
                    </div>
                </vue-tags-input>
                <b-button
                    href='https://ritekit.com/accounts/'
                    target='_blank'
                    variant='outline-secondary'
                    class='btn-connect-account'
                    v-b-tooltip.hover
                    title='Add account'
                >
                    <font-awesome-icon icon='user-plus' />
                </b-button>
            </b-input-group>

            <b-alert
                :show='dismissCountDown'
                dismissible
                fade
                @dismissed='dismissCountDown = 0'
                @dismiss-count-down='countDownChanged'
            >
                You must choose account or service in account selector!
            </b-alert>

            <div id='textarea-post' class='div-textfield'>
                <!-- Text field for post -->
                <b-form-textarea
                    class='mt-2 mb-2'
                    v-model='post'
                    rows='5'
                ></b-form-textarea>

                <span class='span-twitter-count'>
                    <span v-if='twitterSelected'>
                        <strong v-if='postLength < 280' class='text-success'>
                            {{ 280 - postLength }}
                        </strong>
                        <strong v-else class='text-danger'>
                            {{ 280 - postLength }}
                        </strong>
                        <font-awesome-icon
                            class='icon-twitter'
                            :icon='[`fab`, `twitter`]'
                        />&nbsp;
                    </span>
                    <b-link @click='post = ``'>Clear</b-link>
                </span>
            </div>

            <b-button-group id='btn-group-options' class='mr-4 mb-2'>
                <b-button
                    variant='outline-secondary'
                    v-b-tooltip.hover
                    @click='
                        $refs.fileInput.$el
                            .querySelector(`input[type=file]`)
                            .click()
                    '
                    title='Upload .jpg .gif .png with file size less than 5MB'
                >
                    <font-awesome-icon icon='camera' class='fa-fw' />
                    <b-form-file
                        v-model='file'
                        class='form-file-input'
                        ref='fileInput'
                        accept='image/jpeg, image/png, image/gif'
                    ></b-form-file>
                </b-button>
                <b-dropdown variant='outline-secondary' no-caret ref='dropdown'>
                    <template slot='button-content'>
                        <span
                            v-b-tooltip.hover
                            title='Add mood and emotion to lifeless text with just one character'
                        >
                            <font-awesome-icon
                                :icon='[`far`, `smile`]'
                                class='fa-fw'
                            />
                        </span>
                    </template>
                    <Picker
                        class='dropdown-emoji-picker'
                        color='#c12f93'
                        :data='emojiIndex'
                        set='twitter'
                        @select='addEmoji'
                        :showPreview='false'
                        :perLine='10'
                        :emojiTooltip='true'
                    />
                </b-dropdown>
                <b-button
                    variant='outline-secondary'
                    v-b-tooltip.hover
                    title='Create image/GIF from template'
                >
                    <font-awesome-icon icon='paint-brush' />
                </b-button>
                <b-button
                    variant='outline-secondary'
                    v-b-modal.modal-3
                    v-b-tooltip.hover
                    title='Search and add millions of free public images in seconds'
                >
                    <font-awesome-icon :icon='[`far`, `image`]' />
                    <font-awesome-icon
                        icon='search'
                        class='fa-icon-search fa-xs'
                    />
                </b-button>
                <b-button
                    variant='outline-secondary'
                    v-b-modal.modal-4
                    v-b-tooltip.hover
                    title='Search and add millions of animated GIFs in seconds'
                >
                    <strong>GIF</strong>
                    <font-awesome-icon
                        icon='search'
                        class='fa-icon-search fa-xs'
                    />
                </b-button>
                <b-button
                    variant='outline-secondary'
                    v-b-modal.modal-5
                    v-b-tooltip.hover
                    title='Find hashtags'
                >
                    <font-awesome-icon icon='hashtag' />
                </b-button>
                <b-button
                    variant='outline-secondary'
                    v-b-modal.modal-2
                    v-b-tooltip.hover
                    title='Tagsets'
                >
                    <font-awesome-icon icon='tags' />
                </b-button>
                <b-button
                    id='btn-help'
                    variant='outline-secondary'
                    v-b-tooltip.hover
                    title='Help'
                    @click='$tours[`helpTour`].start()'
                >
                    <font-awesome-icon icon='question-circle' />
                </b-button>

                <b-modal id='modal-2' title='Add hashtag sets' hide-footer>
                    <AddHashtagSet
                        v-on:addedHashtagSet='addHashtagToPost($event)'
                    />
                </b-modal>

                <b-modal id='modal-3' title='Search images' hide-footer>
                    <b-row no-gutters>
                        <b-col cols='5'>
                            <b-form-input v-model='image'></b-form-input>
                        </b-col>
                        <b-col cols='3'>
                            <b-form-select
                                v-model='imageSrc'
                                :options='imageOptions'
                            ></b-form-select>
                        </b-col>
                        <b-col>
                            <b-button
                                variant='primary'
                                @click='searchImage(imageSrc, image)'
                            >
                                <font-awesome-icon
                                    v-if='loadingSearch'
                                    icon='spinner'
                                    class='fa-spin'
                                />
                                <font-awesome-icon v-else icon='search' />
                            </b-button>
                        </b-col>
                    </b-row>

                    <b-row no-gutters class='mt-3'>
                        <span
                            v-for='image in imageResults'
                            :key='image.url'
                            class='span-images'
                        >
                            <b-img
                                class='img-result'
                                rounded
                                @click='imageSelected = image'
                                :src='image.image_url'
                            />
                            <br />
                            <font-awesome-icon
                                v-if='image === imageSelected'
                                icon='sort-up'
                                class='fa-2x'
                            />
                        </span>
                    </b-row>

                    <b-img
                        v-if='imageSelected'
                        height='200'
                        class='img-selected mb-3'
                        rounded
                        :src='imageSelected.image_url'
                    ></b-img>
                    <br />
                    <b-button
                        v-if='imageSelected'
                        variant='primary'
                        class='btn-add-img'
                        @click='addImage(imageSrc, imageSelected)'
                        >Add</b-button
                    >
                </b-modal>

                <b-modal id='modal-4' title='Search GIFs' hide-footer>
                    <b-row no-gutters>
                        <b-col cols='5'>
                            <b-form-input v-model='gif'></b-form-input>
                        </b-col>
                        <b-col cols='3'>
                            <b-form-select
                                v-model='gifSrc'
                                :options='gifOptions'
                            ></b-form-select>
                        </b-col>
                        <b-col>
                            <b-button
                                variant='primary'
                                @click='searchImage(gifSrc, gif)'
                            >
                                <font-awesome-icon
                                    v-if='loadingSearch'
                                    icon='spinner'
                                    class='fa-spin'
                                />
                                <font-awesome-icon v-else icon='search' />
                            </b-button>
                        </b-col>
                    </b-row>

                    <b-row no-gutters class='mt-3'>
                        <span
                            v-for='gif in gifResults'
                            :key='gif.url'
                            class='span-images'
                        >
                            <b-img
                                class='img-result'
                                rounded
                                @click='gifSelected = gif'
                                :src='gif.image_url'
                                :alt='gif.image_url_2'
                            />
                            <br />
                            <font-awesome-icon
                                v-if='gif === gifSelected'
                                icon='sort-up'
                                class='fa-2x'
                            />
                        </span>
                    </b-row>

                    <b-img
                        v-if='gifSelected'
                        height='200'
                        class='img-selected mb-3'
                        rounded
                        :src='gifSelected.image_url'
                        :alt='gifSelected.image_url_2'
                    ></b-img>
                    <br />
                    <b-button
                        v-if='gifSelected'
                        variant='primary'
                        class='btn-add-img'
                        @click='addImage(gifSrc, gifSelected)'
                        >Add</b-button
                    >
                </b-modal>

                <b-modal id='modal-5' title='Search hashtags' hide-footer>
                    <b-row>
                        <b-form-input
                            v-model='hashtag'
                            class='form-input-tag'
                        ></b-form-input>
                        <b-button
                            variant='primary'
                            @click='searchHashtag(hashtag)'
                        >
                            <font-awesome-icon
                                v-if='loadingSearch'
                                icon='spinner'
                                class='fa-spin'
                            />
                            <font-awesome-icon v-else icon='search' />
                        </b-button>
                    </b-row>

                    <b-table
                        v-if='hashtagResults.length'
                        class='table-tag'
                        striped
                        borderless
                        :fields='fields'
                        :items='hashtagResults'
                    >
                        <template v-slot:head()='data'>
                            <font-awesome-icon
                                v-if='data.column === `tweets`'
                                :icon='[`fab`, `twitter`]'
                            />
                            <font-awesome-icon
                                v-else-if='
                                    data.column != `add` &&
                                        data.column != `ritetag`
                                '
                                :icon='data.label'
                            />
                        </template>

                        <template v-slot:cell(add)='data'>
                            <b-button
                                v-if='data.item.added'
                                class='btn-table-tag'
                                @click='handleHashtag(data.item, `remove`)'
                                size='sm'
                                variant='danger'
                            >
                                <font-awesome-icon icon='minus-circle' />
                            </b-button>
                            <b-button
                                v-else
                                class='btn-table-tag'
                                @click='handleHashtag(data.item, `add`)'
                                size='sm'
                                variant='success'
                            >
                                <font-awesome-icon icon='plus-circle' />
                            </b-button>
                        </template>

                        <template v-slot:cell(tag)='data'>
                            <b-dropdown
                                size='sm'
                                :text='`#` + data.value'
                                :variant='colors[data.item.color]'
                            >
                                <b-dropdown-item
                                    @click='searchHashtag(data.item.tag)'
                                    >Associated hashtags</b-dropdown-item
                                >
                                <b-dropdown-item
                                    @click='
                                        $bvModal.show(`modal-3`),
                                            (image = data.item.tag),
                                            searchImage(imageSrc, image)
                                    '
                                    >Images</b-dropdown-item
                                >
                                <b-dropdown-item
                                    @click='
                                        $bvModal.show(`modal-4`),
                                            (gif = data.item.tag),
                                            searchImage(gifSrc, gif)
                                    '
                                    >GIFs</b-dropdown-item
                                >
                            </b-dropdown>
                        </template>

                        <template v-slot:cell(exposure)='data'>
                            <span>{{ formatNumber(data.value) }}</span>
                        </template>

                        <template v-slot:cell(ritetag)='data'>
                            <b-button
                                size='sm'
                                :href='
                                    `https://ritetag.com/hashtag-stats/` +
                                        data.item.tag
                                '
                                target='_blank'
                                variant="outline-secondary"
                                v-b-tooltip.hover
                                title='Hashtag stats'
                            >
                                <font-awesome-icon icon='share-square' />
                            </b-button>
                        </template>
                    </b-table>
                </b-modal>
            </b-button-group>

            <b-collapse
                id='collapse-1'
                v-model='showCollapse'
                class='collapse-enhanced mt-1 mb-1'
            >
                <font-awesome-icon icon='magic' />
                Your post has been Enhanced.
                <b-link @click='revert'>Revert to original.</b-link>
            </b-collapse>

            <!-- Enhance button & split dropdown button -->
            <b-dropdown
                id='dropdown-enhance'
                variant='primary'
                split
                class='mr-1'
            >
                <!-- Enhance button -->
                <template slot='button-content'>
                    <span
                        @click='enhance'
                        v-b-tooltip.hover
                        title='Open the dropdown for detailed settings'
                    >
                        <font-awesome-icon
                            v-if='loading'
                            icon='spinner'
                            class='fa-spin'
                        />
                        <font-awesome-icon v-else icon='magic' />
                        Enhance
                    </span>
                </template>

                <!-- Dropdown settings -->
                <b-container class='container-enhance' fluid>
                    <b-row no-gutters class='dropdown-row'>
                        <b>Enhance preset: </b>
                        <b-col class='ml-1 mr-1' cols='4'>
                            <b-form-select
                                v-model='enhanceId'
                                :options='presets'
                                size='sm'
                            ></b-form-select>
                        </b-col>
                        <b-button
                            href='https://ritekit.com/enhance/'
                            target='_blank'
                            variant='outline-secondary'
                            class='dropdown-btn'
                        >
                            <font-awesome-icon icon='cog' />
                        </b-button>
                    </b-row>
                    <b-row class='dropdown-row'>
                        <b-col>
                            <b-form-checkbox
                                v-model='setting.extractImage'
                                @click.native='enhanceId = null'
                            >
                                Extract images from links
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row no-gutters class='dropdown-row'>
                        <b-form-checkbox
                            v-model='setting.quoteImage'
                            class='pr-0'
                            @click.native='enhanceId = null'
                        >
                            Create image/GIF from template
                        </b-form-checkbox>
                        <b-col class='ml-1 mr-1' cols='3.5'>
                            <b-form-select
                                v-model='setting.quoteImageFrom'
                                :options='setting.quoteImageList'
                                size='sm'
                                @click.native='enhanceId = null'
                            ></b-form-select>
                        </b-col>
                        <b-button
                            href='https://ritekit.com/enhance/image'
                            target='_blank'
                            variant='outline-secondary'
                            class='dropdown-btn'
                        >
                            <font-awesome-icon icon='cog' />
                        </b-button>
                    </b-row>
                    <b-row class='dropdown-row'>
                        <b-col>
                            <b-form-checkbox
                                v-model='setting.autoHashtags'
                                @click.native='enhanceId = null'
                            >
                                Auto-hashtag
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row no-gutters class='dropdown-row'>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Max
                        <b-col class='ml-1 mr-1' cols='2'>
                            <b-form-input
                                v-model='setting.maxHashtags'
                                size='sm'
                                @click.native='enhanceId = null'
                                type='number'
                            ></b-form-input>
                        </b-col>
                        hashtags placed
                        <b-col class='ml-1 mr-1' cols='3'>
                            <b-form-select
                                v-model='setting.hashtagPosition'
                                :options='setting.positions'
                                size='sm'
                                @click.native='enhanceId = null'
                            ></b-form-select>
                        </b-col>
                    </b-row>
                    <b-row class='dropdown-row'>
                        <b-col>
                            <b-form-checkbox
                                v-model='setting.autoEmoji'
                                @click.native='enhanceId = null'
                            >
                                Auto-emojify<sup> BETA</sup>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row no-gutters class='dropdown-row'>
                        <b-form-checkbox
                            v-model='setting.shortLink'
                            @click.native='enhanceId = null'
                        >
                            Place my ad on links
                        </b-form-checkbox>
                        <b-col class='ml-1 mr-1' cols='3'>
                            <b-form-select
                                v-model='setting.shortLinkWith'
                                :options='setting.ctaList'
                                size='sm'
                                @click.native='enhanceId = null'
                            ></b-form-select>
                        </b-col>
                        <b-button
                            href='https://rite.ly/dashboard'
                            target='_blank'
                            variant='outline-secondary'
                            class='dropdown-btn'
                        >
                            <font-awesome-icon icon='cog' />
                        </b-button>
                    </b-row>
                    <b-row class='dropdown-row'>
                        <b-col>
                            <b-form-checkbox
                                v-model='setting.twitterHandler'
                                @click.native='enhanceId = null'
                            >
                                Append author's Twitter handle
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row no-gutters class='dropdown-row'>
                        <b-form-checkbox
                            v-model='setting.appendText'
                            @click.native='enhanceId = null'
                        >
                            Append
                        </b-form-checkbox>
                        <b-col class='ml-1 mr-1' cols='4.5'>
                            <b-form-input
                                v-model='setting.appendTextWith'
                                placeholder='text, #hashtag or 😊'
                                size='sm'
                                @click.native='enhanceId = null'
                            ></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class='dropdown-row'>
                        <b-col>
                            <b-form-checkbox
                                v-model='setting.replaceText'
                                @click.native='enhanceId = null'
                            >
                                Replace (default)
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </b-container>
            </b-dropdown>

            <b-dropdown
                id='dropdown-to-queue'
                split
                text='Add to Queue'
                variant='primary'
                @click='addToQueue(`queue`)'
            >
                <b-dropdown-item @click='addToQueue(`now`)'>
                    <font-awesome-icon icon='paper-plane' />
                    Send Now
                </b-dropdown-item>
                <b-dropdown-item v-b-modal.modal-6>
                    <font-awesome-icon :icon='[`far`, `clock`]' />
                    Schedule
                </b-dropdown-item>
                <b-modal title='Select date and time' id='modal-6' hide-footer>
                    <datetime
                        class='date-control theme-ritekit mr-1'
                        input-class='form-control'
                        v-model='date'
                        :min-datetime='minDate'
                        type='datetime'
                        use12-hour
                    />

                    <b-button
                        variant='primary'
                        class='btn-schedule'
                        @click='addToQueue(date), $bvModal.hide(`modal-6`)'
                    >
                        Schedule
                    </b-button>
                </b-modal>
            </b-dropdown>

            <b-alert v-model='showMissingPost' variant='danger' dismissible>
                Missing post
            </b-alert>

            <b-row
                no-gutters
                class='row-images mt-3'
                v-for='(image, index) in addedImages'
                :key='index'
            >
                <b-button-group
                    size='sm'
                    class='btn-group-img-options'
                >
                    <b-button
                        v-b-tooltip.hover
                        title='Remove image'
                        @click='removeImage(image, index)'
                    >
                        <font-awesome-icon icon='times' class='fa-fw' />
                    </b-button>
                    <b-button
                        v-b-tooltip.hover
                        title='Opens in new tab for downloading'
                        :href='image.image_url'
                        target='_blank'
                    >
                        <font-awesome-icon icon='cloud-download-alt' />
                    </b-button>
                </b-button-group>
                <b-img
                    thumbnail
                    height='200'
                    class='img-selected'
                    :src='image.image_url'
                ></b-img>
            </b-row>

            <v-tour name='helpTour' :steps='steps' :options='helpOptions'>
                <template slot-scope='tour'>
                    <transition name='fade'>
                        <v-step
                            v-if='tour.currentStep === index'
                            v-for='(step, index) of tour.steps'
                            :key='index'
                            :step='step'
                            :previous-step='tour.previousStep'
                            :next-step='tour.nextStep'
                            :stop='tour.stop'
                            :is-first='tour.isFirst'
                            :is-last='tour.isLast'
                            :labels='tour.labels'
                        >
                            <template v-if='tour.currentStep === 6'>
                                <div slot='content' class='step-content'>
                                    If you ever need any more help, you can
                                    always click here to start the tour again or
                                    go to
                                    <a
                                        href='https://ritetag.com/help'
                                        target='_blank'
                                        class='link-ritekit-help'
                                        >RiteKit Help</a
                                    >
                                    for all our tutorials.
                                </div>
                            </template>
                        </v-step>
                    </transition>
                </template>
            </v-tour>
        </b-modal>
    </div>
</template>

<script>
import {api} from '../../_services'
import VueTagsInput from '@johmun/vue-tags-input'
import twitterText from 'twitter-text'
import AddHashtagSet from './AddHashtagSet'
import moment from 'moment'
import data from 'emoji-mart-vue-fast/data/all.json'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import 'emoji-mart-vue-fast/css/emoji-mart.css'

export default {
    name: 'Composer',
    components: {
        VueTagsInput,
        AddHashtagSet,
        Picker
    },
    data() {
        return {
            post: '',
            oldPost: null,
            account: '',
            accounts: [],
            accountsToQueue: [],
            autocompleteItems: [],
            enhanceId: null,
            presets: [{ text: 'Custom', value: null }],
            presetsSettings: {},
            setting: {},
            loading: false,
            showCollapse: false,
            showMissingPost: false,
            dismissSecs: 5,
            dismissCountDown: 0,
            twitterSelected: false,
            twitterAccounts: new Set(),
            date: moment().format(),
            image: null,
            imageSrc: 'twitter',
            imageOptions: [
                { value: 'twitter', text: 'Twitter' },
                { value: 'flickr', text: 'Flickr' },
                { value: 'imgur', text: 'Imgur' }
            ],
            imageResults: [],
            imageSelected: null,
            gif: null,
            gifSrc: 'giphy',
            gifOptions: [{ value: 'giphy', text: 'Giphy' }],
            gifResults: [],
            gifSelected: null,
            addedImages: [],
            loadingSearch: false,
            file: null,
            emojiIndex: new EmojiIndex(data),
            hashtag: null,
            hashtagResults: [],
            fields: [
                { key: 'add' },
                { key: 'tag', label: 'tags' },
                { key: 'tweets', label: 'twitter' },
                { key: 'retweets', label: 'retweet' },
                { key: 'exposure', label: 'eye' },
                { key: 'ritetag' }
            ],
            colors: [
                'unused-hashtag',
                'overused-hashtag',
                'poor-hashtag',
                'good-hashtag',
                'instagram-hashtag',
                'instagram-banned-hashtag'
            ],
            helpOptions: {
                labels: {
                    buttonSkip: 'Skip',
                    buttonPrevious: '← Back',
                    buttonNext: 'Next →',
                    buttonStop: 'Done'
                }
            },
            steps: [
                {
                    target: '#modal-1___BV_modal_content_',
                    content: `Welcome! Let's go through creating awesome posts with hashtags, images and CTAs using the RiteKit Composer.`
                },
                {
                    target: '#input-group',
                    content: `Here's where you select the accounts you want to post as. Click inside the field to select a profile.`
                },
                {
                    target: '#textarea-post',
                    content:
                        'Type here. Click a hashtag to display current stats. Click a link to show options for shortening and adding a Call-To-Action.'
                },
                {
                    target: '#dropdown-enhance',
                    content: `Auto-Enhance is the tool you'll likely use the most. With just a click, Auto-Enhance adds the best hashtags for your post and attaches gorgeous images whenever possible.`
                },
                {
                    target: '#btn-group-options',
                    content: `You can also manually search and add images and gifs, find the best hashtags for a topic, see what's trending now, and much more.`
                },
                {
                    target: '#dropdown-to-queue',
                    content:
                        'Once your post is ready, you can Add it to Queue. You can also set a specific time or send now by selecting from the dropdown.'
                },
                { target: '#btn-help' }
            ]
        }
    },
    methods: {
        enhance() {
            this.loading = true
            this.oldPost = this.post
            if (this.enhanceId) {
                api.enhanceWithPreset(this.enhanceId, this.post)
                    .then(response => {
                        this.post = response.data.post
                        this.showCollapse = true
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                api.enhanceCustom(this.setting, this.post)
                    .then(response => {
                        this.post = response.data.post
                        this.showCollapse = true
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        revert() {
            this.showCollapse = false
            this.post = this.oldPost
        },
        addToQueue(time) {
            if (this.accountsToQueue.length < 1) {
                this.dismissCountDown = this.dismissSecs
            } else if (this.post.length < 1) {
                this.showMissingPost = true
            } else {
                var formData = new FormData()
                formData.append('accounts[]', this.accountsToQueue)
                formData.append('scheduledAt[]', time)
                formData.set('text', this.post)
                this.addedImages.forEach((item, index) => {
                    formData.append(
                        'images[' + index + '][url]',
                        item.image_url
                    )
                })

                api.postToQueue(formData)
                    .catch(() => { })
                    .finally(() => {
                        this.resetComposer()
                    })
            }
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        addHashtagToPost(tagset) {
            for (let hashtag in tagset) {
                if (!this.post.includes(tagset[hashtag].name)) {
                    this.post += ' ' + tagset[hashtag].name
                }
            }
            this.$bvModal.hide('modal-2')
        },
        searchImage(source, image) {
            this.loadingSearch = true
            api.getImageWithSource(source, image)
                .then(response => {
                    if (source === 'twitter') {
                        response.data.photos.forEach(item => {
                            item.image_url = item.url
                        })
                    }

                    if (source === 'giphy') {
                        this.gifSelected = null
                        this.gifResults = []
                        response.data.photos.forEach(item => {
                            api.getUrl(item.image_url)
                                .then(() => {
                                    this.gifResults.push(item)
                                    if (!this.gifSelected) {
                                        this.gifSelected = this.gifResults[0]
                                    }
                                })
                                .catch(() => {})
                                .finally(() => {
                                    if (this.loadingSearch)
                                        this.loadingSearch = false
                                })
                        })
                    } else {
                        this.imageSelected = null
                        this.imageResults = []
                        response.data.photos.forEach(item => {
                            api.getUrl(item.image_url)
                                .then(() => {
                                    this.imageResults.push(item)
                                    if (!this.imageSelected) {
                                        this.imageSelected = this.imageResults[0]
                                    }
                                })
                                .catch(() => {})
                                .finally(() => {
                                    if (this.loadingSearch)
                                        this.loadingSearch = false
                                })
                        })
                    }
                })
        },
        addImage(source, image) {
            if (source === 'giphy') {
                this.$bvModal.hide('modal-4')
            } else {
                this.$bvModal.hide('modal-3')
            }
            if (source === 'twitter') {
                this.post += ' 📷 @' + image.screenName
            } else {
                this.post += ' 📷 @' + source + ' ' + image.url
            }
            image.source = source
            this.addedImages.push(image)
        },
        removeImage(image, index) {
            this.addedImages.splice(index, 1)
            if (image.tweetId) {
                this.post = this.post.replace(' 📷 @' + image.screenName, '')
            } else {
                this.post = this.post.replace(
                    ' 📷 @' + image.source + ' ' + image.url,
                    ''
                )
            }
        },
        addEmoji(emoji) {
            this.post += emoji.native
            this.$refs.dropdown.hide(true)
        },
        searchHashtag(hashtag) {
            this.loadingSearch = true
            this.hashtag = hashtag
            api.searchHashtags(hashtag, 30)
                .then(response => {
                    this.hashtagResults = []
                    response.data.result.forEach(item => {
                        var added = false
                        if (this.post.includes(' #' + item.tag)) {
                            added = true
                        }
                        item.added = added
                        this.hashtagResults.push(item)
                    })
                })
                .finally(() => {
                    if (this.loadingSearch) this.loadingSearch = false
                })
        },
        formatNumber(n) {
            if (n < 1e3) return n
            if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + 'K'
            if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + 'M'
            if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + 'B'
            if (n >= 1e12) return +(n / 1e12).toFixed(1) + 'T'
        },
        handleHashtag(item, handler) {
            if (handler === 'remove') {
                this.post = this.post.replace(' #' + item.tag, '')
            } else {
                this.post += ' #' + item.tag
            }
            item.added = !item.added
        },
        resetComposer() {
            this.$bvModal.hide('modal-1')
            this.accounts = []
            this.accountsToQueue = []
            this.post = ''
            this.addedImages = []
            this.image = ''
            this.imageResults = []
            this.gif = ''
            this.gifResults = []
            this.hashtag = ''
            this.hashtagResults = []
            this.showMissingPost = false
        }
    },
    watch: {
        enhanceId: function (val) {
            if (val && this.presetsSettings[this.enhanceId]) {
                this.setting = JSON.parse(
                    JSON.stringify(this.presetsSettings[this.enhanceId])
                )
            }
        },
        accounts: function (val) {
            this.accountsToQueue = []
            this.twitterSelected = false
            val.forEach(item => {
                if (item.network === 'users') {
                    // Is a group account
                    item.accounts.forEach(id => {
                        if (!this.accountsToQueue.includes(id)) {
                            this.accountsToQueue.push(id)
                        }
                        if (this.twitterAccounts.has(id)) {
                            this.twitterSelected = true
                        }
                    })
                } else {
                    if (!this.accountsToQueue.includes(item.id)) {
                        this.accountsToQueue.push(item.id)
                    }
                    if (this.twitterAccounts.has(item.id)) {
                        this.twitterSelected = true
                    }
                }
            })
        },
        file: function (val) {
            if (val) {
                var file = this.file
                var formData = new FormData()
                formData.append('file', file)
                formData.set('filename', file.name)
                formData.set('filesize', file.size)

                api.uploadImage(formData)
                    .then(response => {
                        var image = { image_url: response.data.file.uri }
                        this.addedImages.push(image)
                    })
            }
        }
    },
    computed: {
        filteredItems() {
            return this.autocompleteItems.filter(i => {
                return (
                    i.text.toLowerCase().indexOf(this.account.toLowerCase()) !==
                    -1
                )
            })
        },
        postLength() {
            return twitterText.parseTweet(this.post).weightedLength
        },
        minDate() {
            return moment().format()
        }
    },
    created() {
        api.getPresets()
            .then(response => {
                var defaultId = response.data.sets[0].id
                response.data.sets.forEach(item => {
                    this.presets.push({
                        text: item.name,
                        value: item.id
                    })

                    api.getPresetDetail(item.id)
                        .then(response => {
                            var quoteImageList = [
                                { text: 'Random', value: null }
                            ]
                            response.data.settings.quoteImageList.forEach(
                                item => {
                                    quoteImageList.push({
                                        text: item.name,
                                        value: item.id
                                    })
                                }
                            )

                            var ctaList = []
                            response.data.settings.ctaList.forEach(item => {
                                ctaList.push({
                                    text: item.name,
                                    value: item.id
                                })
                            })

                            this.presetsSettings[item.id] =
                                response.data.settings
                            this.presetsSettings[
                                item.id
                            ].quoteImageList = quoteImageList
                            this.presetsSettings[item.id].positions = [
                                { text: 'anywhere', value: 'auto' },
                                { text: 'at the end', value: 'end' }
                            ]
                            this.presetsSettings[item.id].ctaList = ctaList

                            if (item.id === defaultId) {
                                this.enhanceId = item.id
                            }
                        })
                })
            })

        api.getAccounts()
            .then(response => {
                response.data.accounts.forEach(item => {
                    var style = 'background-color: #000000'
                    var network = item.network
                    var text = network + ' ' + item.name
                    var avatar = item.avatar
                    var fa = 'fab'
                    var accounts = []

                    switch (item.network) {
                        case 'twitter':
                            style = 'background-color: #00AEF8'
                            this.twitterAccounts.add(item.id)
                            break
                        case 'facebook':
                            style = 'background-color: #3b5998'
                            network += '-f'
                            break
                        case 'pinterest':
                            style = 'background-color: #C92228'
                            network += '-p'
                            break
                        case 'linkedin':
                            style = 'background-color: #0976b4'
                            network += '-in'
                            break
                        case 'group':
                            style = 'background-color: #515151'
                            network = 'users'
                            fa = 'fas'
                            avatar = ''
                            accounts = item.accounts
                            break
                    }
                    api.getUrl(avatar)
                        .catch(() => {
                            avatar = ''
                        })
                        .finally(() => {
                            this.autocompleteItems.push({
                                avatar: avatar,
                                id: item.id,
                                network: network,
                                service: item.service,
                                text: text,
                                style: style,
                                fa: fa,
                                accounts: accounts
                            })
                        })
                })
            })
    }
}
</script>


<style lang='scss'>
.vue-tags-input {
    width: calc(100% - 47px);
}

.vue-tags-input .ti-input, .ti-autocomplete {
    border: 1px solid #CBD5E0 !important;
    border-radius: 0.25rem;
    padding: 1.5px;
    min-height: 33px;
}

.vue-tags-input .ti-autocomplete {
    border-top: none !important;
}

.vue-tags-input .ti-tag {
    height: 26px;
}

.vue-tags-input .ti-item.ti--item {
    background: #f5f5f5 !important;
    color: #000000 !important;
}

.vue-tags-input .ti-item {
    background: #ffffff !important;
    color: #000000 !important;
}

.btn-connect-account {
    height: 33px;
    margin-left: 3px;
}

.dropdown-row {
    line-height: 200%;
}

.dropdown-btn {
    height: 30px;
    line-height: 1.2 !important;
}

.dropdown-item {
    padding: 0.25rem 1rem !important;
}

.dropdown-menu {
    min-width: 8rem !important;
}

.alert {
    margin-top: 0.75rem;
    margin-bottom: 0rem !important;
}

.span-twitter-count {
    position: absolute;
    right: 10px;
    bottom: 5px;
}

.fa-icon-search {
    position: absolute;
    bottom: 5px;
    right: 3px;
}

.date-control {
    width: 200px;
    display: inline-block;
}

.theme-ritekit .vdatetime-popup__header,
.theme-ritekit .vdatetime-calendar__month__day--selected > span > span,
.theme-ritekit .vdatetime-calendar__month__day--selected:hover > span > span {
    background: #c12f93;
}

.theme-ritekit .vdatetime-year-picker__item--selected,
.theme-ritekit .vdatetime-time-picker__item--selected,
.theme-ritekit .vdatetime-popup__actions__button {
    color: #c12f93;
}

.img-result {
    width: 34px;
    height: 34px;
    object-fit: cover;
}

.dropdown-emoji-picker {
    margin: -10px -1px -10px;
    position: absolute;
    left: -43px;
}

.form-input-tag {
    width: 60% !important;
}

.table-tag {
    margin-left: -45px;
}

.btn-table-tag {
    height: 28px;
    line-height: 1;
}

.table th,
.table td {
    padding: 8px !important;
    vertical-align: middle !important;
}

.btn-unused-hashtag,
.btn-overused-hashtag,
.btn-poor-hashtag,
.btn-good-hashtag,
.btn-instagram-hashtag,
.btn-instagram-banned-hashtag {
    line-height: 1.2 !important;
    border-radius: 0 !important;
    color: white !important;
}

.btn-unused-hashtag {
    background-color: $unused !important;
}

.btn-overused-hashtag {
    background-color: $overused !important;
}

.btn-poor-hashtag {
    background-color: $poor !important;
}

.btn-good-hashtag {
    background-color: $good !important;
}

.btn-instagram-hashtag {
    background: $instagram-moz !important;
    background: $instagram-webkit !important;
    background: $instagram !important;
}

.btn-instagram-banned-hashtag {
    background-color: $instagram-banned !important;
}

.fa-close-btn {
    position: absolute;
    top: 5px;
    right: 5px;
}

.v-step {
    background: $gray-700 !important;
}

.v-step__arrow {
    border-color: $gray-700 !important;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
}

.link-ritekit-help {
    color: $blue-400;
}

.div-textfield {
    position: relative;
}

.icon-twitter {
    color:#00AEF8;
}

.icon-close {
    cursor: pointer;
}

.form-file-input {
    display: none !important;
}

.span-images {
    text-align: center; 
    height: 55px; 
    margin-right: 3px;
}

.img-selected {
    max-width: 370px;
}

.btn-add-img {
    margin-left: 45%;
}

.step-content {
    margin: 0 0 1rem;
}

.collapse-enhanced {
    font-size: 12px;
}

.container-enhance {
    width: 420px !important;
}

.btn-schedule {
    margin-top: -3px;
}

.row-images {
    position: relative;
}

.btn-group-img-options {
    position: absolute !important; 
    opacity: 0.7;
}
</style>
